import { Field } from "@/components/ui/Field"
import { InputHTMLAttributes } from "react"
import { UseFormRegister } from "react-hook-form"
import BaseInput from "./BaseInput"

/** Labelled react-hook-form text input: Field (label, error, ids) around BaseInput. */
export default function Input<T extends Record<string, unknown>>({
  name,
  label,
  error,
  errorMsg,
  registerAction,
  required,
  ...props
}: Omit<InputHTMLAttributes<HTMLInputElement>, "name" | "size" | "prefix"> & {
  name: string
  label: string
  error: boolean
  errorMsg?: string
  registerAction: UseFormRegister<T>
  /** Marks the label with *. Defaults to true when errorMsg is provided. */
  required?: boolean
}) {
  return (
    <Field
      id={name + label}
      label={label}
      required={required ?? Boolean(errorMsg)}
      invalid={error}
      error={error ? errorMsg : undefined}
    >
      <BaseInput
        name={name}
        label={label}
        error={error}
        registerAction={registerAction}
        required={required}
        {...props}
      />
    </Field>
  )
}
